var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video"},[(_vm.src)?_c('video',{ref:"video",attrs:{"src":_vm.src,"muted":"","autoplay":"","loop":_vm.loop},domProps:{"muted":true},on:{"ended":_vm.ended,"error":_vm.error}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }